module.exports = __webpack_public_path__ + "static/img/bg-sai-apply.7e54dba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-sai-apply.png
// module id = 814
// module chunks = 0